
import ApiKeysTable from "../../Components/ApiKeysTable.jsx";
import APIKeyUsageTable from "../../Components/ApiKeyUsageTable.jsx";
import KeyGenerateModal from "../../Components/KeyGenerateModal.jsx";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import SubscriptionBilling from "../../Components/SubscriptionBilling.jsx";
import { GenerateKeyAction } from "../../store/Actions/action.js";
import useApiKeys from "./useApiKeys.js";
import {
  ArrowPathIcon,
  KeyIcon,
} from '@heroicons/react/24/outline';



export default function ApiKeys() {
  // Dummy Data
  const apiUsage = 3500;
  const apiLimit = 5000;
  const usagePercent = (apiUsage / apiLimit) * 100;
  const alertsCount = 4;
const {apiKeysList, 
     showKeyModal,
    setShowKeyModal,
  onClickGenerate}=useApiKeys()
  return (
    <>
  <div className="min-h-screen p-4 ">
      <ApiKeysTable onGenerateKey={onClickGenerate} keysData={apiKeysList} />
    </div>
    <SimpleFooter/>
    <KeyGenerateModal open={showKeyModal}  onClose={()=>setShowKeyModal(false)}/>
    </>
  );
}
